// extracted by mini-css-extract-plugin
export default {"p_tye":"_9a19e89a45","slcted":"_2c04283e65","slc_color":"_5f48f05591","item_p":"_13e226e64a","r0":"_6d25763312"};